// react-dnd DragType contexts
export const DRAG_TYPES = {
  MODULE: 'module',
  ADD_MODULE: 'addModule',
  CUSTOM_SECTION: 'customSection',
  ADD_BUILDING_BLOCK: 'addBuildingBlock'
};